import { Reveal, Eyebrow } from "./Reveal";

const STEPS = [
    {
        step: "01",
        title: "Il primo contatto",
        text: "Un primo momento per raccontare ciò che stai vivendo e capire insieme da dove iniziare.",
    },
    {
        step: "02",
        title: "L'ascolto",
        text: "Uno spazio dedicato alla comprensione della tua esperienza, delle tue emozioni e dei tuoi bisogni.",
    },
    {
        step: "03",
        title: "Il percorso",
        text: "Un lavoro costruito progressivamente sulla persona e sulle sue esigenze.",
    },
    {
        step: "04",
        title: "La consapevolezza",
        text: "Imparare a guardare se stessi e ciò che accade con maggiore consapevolezza.",
    },
];

export const Percorso = () => (
    <section id="percorso" className="bg-sand/70" data-testid="percorso-section">
        <div className="max-w-7xl mx-auto px-6 sm:px-12 lg:px-20 py-20 md:py-32">
            <Reveal className="max-w-2xl">
                <Eyebrow>Come inizia</Eyebrow>
                <h2 className="mt-4 font-serif text-3xl sm:text-4xl lg:text-5xl leading-snug text-ink" data-testid="percorso-title">
                    Il percorso, passo dopo passo
                </h2>
            </Reveal>

            <div className="mt-14 relative">
                <div className="absolute left-6 lg:left-1/2 top-0 bottom-0 w-px bg-ink/10 lg:-translate-x-1/2" aria-hidden="true" />
                <div className="space-y-10 lg:space-y-0">
                    {STEPS.map((s, i) => (
                        <Reveal key={s.step} delay={0.05}>
                            <div
                                className={`relative lg:grid lg:grid-cols-2 lg:gap-16 items-center ${i > 0 ? "lg:mt-[-2rem]" : ""}`}
                                data-testid={`percorso-step-${i}`}
                            >
                                <div className={`pl-16 lg:pl-0 ${i % 2 === 0 ? "lg:pr-16 lg:text-right" : "lg:col-start-2 lg:pl-16"}`}>
                                    <span className="font-serif text-5xl sm:text-6xl text-terracotta/50">{s.step}</span>
                                    <h3 className="mt-2 font-serif text-2xl font-semibold text-ink">{s.title}</h3>
                                    <p className="mt-3 text-base text-[#526063] leading-relaxed max-w-md lg:inline-block">{s.text}</p>
                                </div>
                                <span className="absolute left-6 lg:left-1/2 top-2 -translate-x-1/2 h-3.5 w-3.5 rounded-full bg-sage border-4 border-cream shadow" aria-hidden="true" />
                            </div>
                        </Reveal>
                    ))}
                </div>
            </div>
        </div>
    </section>
);
